import { baseApi } from "@/shared/api";
import type { ChatPerson } from "../types";

export const chatPeopleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatPeople: builder.query<ChatPerson[], string | void>({
      query: (search) => ({
        url: "/api/chat/people/",
        method: "GET",
        params: search ? { search } : undefined,
        credentials: "include" as const,
      }),
      providesTags: [{ type: "ChatPeople", id: "LIST" }],
    }),
  }),
});

export const { useGetChatPeopleQuery } = chatPeopleApi;
